module.exports = __webpack_public_path__ + "static/media/yampi2.6aeca740.png";